import styles from "./stepbar.module.scss"
import SText from "../Text/SText"
import Image from "next/image"
import { CSSProperties } from "react"

export default function StepBar({
  currentStep,
  steps,
  style,
}: {
  currentStep: number
  steps: string[]
  style: CSSProperties
}) {
  return (
    <div style={style} className={styles.stepContainer}>
      <div className={styles.stepWrapper}>
        {steps.map((step, index) => (
          <div key={index} className={steps.length - 1 == index ? styles.lastStepBlock : styles.stepBlock}>
            {/* Step Circle with Animation */}
            <div className={`${styles.circle} ${index + 1 <= currentStep ? styles.animatedCircle : ""}`}>
              {index + 1 <= currentStep ? (
                <div className={styles.inactiveCircleContainer}>
                  <Image
                    width={24}
                    height={24}
                    src={"/svg/check_circle.svg"}
                    className={styles.activeCircle}
                    alt={"checked"}
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              ) : (
                <div className={styles.inactiveCircleContainer}>
                  <div className={styles.inactiveCircle}></div>
                </div>
              )}
              <SText style={{ marginLeft: "4px" }} variant={"bodySmall"} size={14} color={"green300"}>
                {step}
              </SText>
            </div>

            {/* Step Line Animation */}
            {index < steps.length - 1 && (
              <div
                className={`${styles.stepLine} ${index + 1 < currentStep ? styles.activeLine : styles.inactiveLine}`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
